import { Box, BoxProps } from '@mui/material';
import styled from 'styled-components';

export const StyledCincopaContainer = styled.div`
  width: 100%;
  background: #f2f3f9;
  border-radius: 0px 0px 10px 10px;
  overflow: hidden;
`;

export const GalleryWidgetRoot = styled(Box)<{ $compact?: boolean }>`
  margin-top: ${({ $compact, theme }) => ($compact ? 0 : theme.spacing(2))};
  background-color: #ffffff;
  padding: ${({ theme }) => theme.spacing(3)};
  border-radius: ${({ $compact, theme }) =>
    $compact ? `0 0 ${theme.spacing(3)} ${theme.spacing(3)}` : theme.spacing(3)};
`;

export const GalleryItem = styled(Box)`
  position: relative;
  max-width: 150px;
  max-height: 150px;
  width: 100%;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
  background-color: #e1e6eb;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: ${({ theme }) => theme.spacing(0, 2)};
`;

export const PlaceholderBox = styled(GalleryItem)<{ $clickable?: boolean }>`
  cursor: ${'pointer'};
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
  user-select: none;
  width: 150px;
  height: 150px;
  transition: background-color 0.2s ease, color 0.2s ease;

  ${({ $clickable }) =>
    $clickable &&
    `
  &:hover {
    background-color: #d1d5db;
    color: #374151;
  }
  `}
`;

export const GalleryIconBox = styled(Box)<BoxProps>`
  display: flex;
  align-items: flex-end;
  padding-right: ${({ theme }) => theme.spacing(1)} ;
  padding-left: ${({ theme }) => theme.spacing(1)} ;
  position: absolute;
  bottom: ${({ theme }) => theme.spacing(2)};
  cursor: pointer;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.1);
  }
`;
